module.exports = __webpack_public_path__ + "static/media/default-img.cc18b607.svg";